module.exports = __webpack_public_path__ + "img/type10.8eb7048a.png";